"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var ROICalculatorLayout_1 = require("ContentTokens/SharedWidgetComponents/ROICalculator/ROICalculatorLayout");
var ROICalculatorPanelContents_1 = require("ContentTokens/SharedWidgetComponents/ROICalculator/ROICalculatorPanelContents/ROICalculatorPanelContents");
var ROICalculatorResultNumber_1 = require("ContentTokens/SharedWidgetComponents/ROICalculator/ROICalculatorResultNumber");
var ROICalculatorSlider_1 = require("ContentTokens/SharedWidgetComponents/ROICalculator/ROICalculatorSlider");
var mobx_1 = require("mobx");
var ROICalculatorUtils_1 = require("ContentTokens/SharedWidgetComponents/ROICalculator/ROICalculatorUtils");
var mobx_react_1 = require("mobx-react");
var ROICalculatorViewStore_1 = require("./ROICalculatorViewStore");
var ROICalculatorResultEvaluator_1 = require("ContentTokens/SharedWidgetComponents/ROICalculator/ROICalculatorResultEvaluator/ROICalculatorResultEvaluator");
var ROICalculatorVariableInputField_1 = require("ContentTokens/SharedWidgetComponents/ROICalculator/ROICalculatorVariableInputField");
var lodash_1 = require("lodash");
var Telemetry_1 = require("Public/Telemetry/Telemetry");
var TelemetryEnums_1 = require("Telemetry/TelemetryEnums");
var hydrationHelpers_1 = require("../hydrationHelpers");
var classnames_1 = __importDefault(require("classnames"));
var ROICalculator = (function (_super) {
    __extends(ROICalculator, _super);
    function ROICalculator(props) {
        var _this = _super.call(this, props) || this;
        _this.trackVariableInputInteraction = function (variableId) {
            var inputKeys = Object.keys(_this.viewStore.inputs);
            var count = inputKeys.length;
            var index = (0, lodash_1.findIndex)(inputKeys, function (x) { return x === variableId; });
            if (_this.telemetry) {
                _this.telemetry.track(TelemetryEnums_1.ROICalculatorInteractions.VariableChanged, {
                    roi_interaction_location: TelemetryEnums_1.TelemetryContext.Public,
                    roi_input_variable_count: count,
                    roi_input_variable_value_position: index,
                });
            }
        };
        _this.trackSliderInteraction = function () {
            if (_this.telemetry) {
                _this.telemetry.debouncedTrack(TelemetryEnums_1.ROICalculatorInteractions.SliderMoved, {
                    roi_interaction_location: TelemetryEnums_1.TelemetryContext.Public,
                });
            }
        };
        _this.handleSliderValueChange = function (sliderValue) {
            _this.trackSliderInteraction();
            _this.viewStore.updateSlider(sliderValue);
        };
        _this.handleVariableValueChange = function (id, newValue) {
            _this.viewStore.updateInputValue(id, Number(newValue));
        };
        _this.viewStore = new ROICalculatorViewStore_1.ROICalculatorViewStore(props.payload);
        _this.telemetry = Telemetry_1.Telemetry.getInstance();
        return _this;
    }
    ROICalculator.prototype.render = function () {
        var _this = this;
        var _a = this.props.payload, slider = _a.slider, roiResult = _a.roiResult, title = _a.title, description = _a.description, backgroundImageUrl = _a.backgroundImageUrl, useStaticRangeInput = _a.useStaticRangeInput;
        var roiResultLabel = (0, ROICalculatorUtils_1.getPlainTextFromRoiRichText)(roiResult.label);
        var titleText = (0, ROICalculatorUtils_1.getPlainTextFromRoiRichText)(title);
        var descriptionText = (0, ROICalculatorUtils_1.getPlainTextFromRoiRichText)(description);
        return (react_1.default.createElement("div", { className: "roi-calculator-public" },
            react_1.default.createElement(ROICalculatorLayout_1.ROICalculatorLayout, { widgetId: this.widgetId, backgroundImageUrl: backgroundImageUrl, calculator: react_1.default.createElement(ROICalculatorPanelContents_1.ROICalculatorPanelContents, { widgetId: this.widgetId, description: react_1.default.createElement("div", { className: "roi-calculator-typography__calculator-description" }, descriptionText), title: react_1.default.createElement("div", { className: "roi-calculator-typography__calculator-title" }, titleText), inputs: react_1.default.createElement("div", { className: "space-inset-l" }, Object.entries(this.viewStore.inputs).map(function (_a) {
                        var _b = __read(_a, 2), variableId = _b[0], variable = _b[1];
                        return (react_1.default.createElement("div", { key: variableId, className: "space-stack-m" },
                            react_1.default.createElement(ROICalculatorVariableInputField_1.ROICalculatorVariableInputField, { label: "(".concat(variableId, ") ").concat(variable.label), value: variable.value.toString(), onChange: function (_, value) {
                                    _this.handleVariableValueChange(variableId, value);
                                }, min: variable.min, max: variable.max, prefix: variable.prefix, suffix: variable.suffix, onValueEdited: function () { return _this.trackVariableInputInteraction(variableId); } })));
                    })) }), result: function (_a) {
                    var containerWidth = _a.containerWidth;
                    return (react_1.default.createElement("div", null,
                        react_1.default.createElement("div", { className: "roi-calculator-result__inner" },
                            react_1.default.createElement(ROICalculatorResultNumber_1.ROICalculatorResultNumber, { containerWidth: containerWidth, value: _this.result, prefix: roiResult.prefix, suffix: roiResult.suffix })),
                        react_1.default.createElement("div", { className: "roi-calculator-result__label" },
                            react_1.default.createElement("div", { "data-qwilr-component": "roi-calculator-label", "data-qwilr-widgetid": _this.widgetId, className: "roi-calculator-typography__result-label" }, roiResultLabel))));
                }, slider: function () {
                    return typeof document === "undefined" ? undefined : (react_1.default.createElement("div", { className: "roi-calculator-slider__container" },
                        react_1.default.createElement(ROICalculatorSlider_1.ROICalculatorSlider, { widgetId: _this.widgetId, label: slider.label, onValueChange: _this.handleSliderValueChange, value: _this.viewStore.sliderValue, min: slider.min, max: slider.max, increment: slider.increment, useStaticRangeInput: useStaticRangeInput })));
                } })));
    };
    Object.defineProperty(ROICalculator.prototype, "result", {
        get: function () {
            var variableInputs = this.viewStore.inputs;
            var sliderValue = this.viewStore.sliderValue;
            var roiResult = this.props.payload.roiResult;
            var formula = roiResult.formula;
            var formattedResult = "--";
            try {
                var calculatedResult = (0, ROICalculatorResultEvaluator_1.substituteAndCalculateRoiResult)(formula, variableInputs, sliderValue);
                formattedResult = (0, ROICalculatorUtils_1.roundAndFormatRoiResult)(calculatedResult);
            }
            catch (_a) { }
            return formattedResult;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ROICalculator.prototype, "widgetId", {
        get: function () {
            return this.props.payload.id;
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        mobx_1.computed,
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], ROICalculator.prototype, "result", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ROICalculator.prototype, "handleSliderValueChange", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ROICalculator.prototype, "handleVariableValueChange", void 0);
    ROICalculator = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], ROICalculator);
    return ROICalculator;
}(react_1.default.Component));
var HydratableROICalculator = function (_a) {
    var payload = _a.payload, attributes = _a.attributes;
    return (react_1.default.createElement("div", __assign({}, attributes, { className: (0, classnames_1.default)("roi-calculator", attributes.className) }),
        react_1.default.createElement(ROICalculator, { payload: payload })));
};
exports.default = (0, hydrationHelpers_1.withHydrationHost)(HydratableROICalculator, { componentName: "ROICalculator" });
